module.exports = __webpack_public_path__ + "img/0682136.webp";